import { ExportColumn } from '../types';

export const resolveNormalizedColumnType = (column: ExportColumn): string =>
  column.formatConfig.type?.toLowerCase() ?? '';
